import { faCircleXmark, faTrashAlt } from '@fortawesome/free-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React, { useEffect, useState } from 'react';
import styles from './index.module.css';
import { useDispatch, useSelector } from 'react-redux';
import {
  getBanners,
  removeBanner,
} from '../../../redux/features/banner/bannerService';
import Skeleton from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';
import { faPlus, faXmark } from '@fortawesome/free-solid-svg-icons';
import NoResultsFound from '../../../components/NoResultsFound';
import { useNavigate } from 'react-router-dom';
import { showToast } from '../../../components/ToastMsg';
import Modal from '../../../components/Modal';

const Banner = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [isModalOpen, setModalOpen] = useState(false);
  const [reload, setReload] = useState(false);
  const [selectedBannerId, setSelectedBannerId] = useState(null);

  const { isBannerLoading, banners } = useSelector(
    (state) => state.banner.getBanners
  );

  useEffect(() => {
    dispatch(getBanners({ status: true }));
  }, [dispatch, reload]);

  return (
    <div className={`main-card`}>
      <h1 className={`form-title ${styles.headDiv}`}>
        Banners
      </h1>
      <div>
        {isBannerLoading ? (
          <table>
            <tbody>
              {Array.from({ length: 5 }).map((_, index) => (
                <tr key={index}>
                  <td>
                    <Skeleton className={styles.imgBannerSkeleton} />
                  </td>
                  <td>
                    <Skeleton className={styles.mobileImgBannerSkeleton} />
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        ) : banners.length > 0 ? (
          <table>
            <tbody>
              {banners.map((banner, index) => (
                <tr key={index}>
                  <td className={styles.td}>
                    <div className={styles.bannerWrapper}>
                      <img
                        className={styles.imgBanner}
                        src={banner.image_url}
                        alt={banner.alt_text}
                      />
                    </div>
                  </td>
                  <td className={styles.td}>
                    <img
                      className={styles.mobileImgBanner}
                      src={banner.image_url_for_mobile}
                      alt={banner.alt_text}
                    />
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        ) : (
          <NoResultsFound />
        )}
      </div>
    </div>
  );
};

export default Banner;
